import { useEffect, useState } from "react";
import { Container, Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import "react-image-gallery/styles/css/image-gallery.css";
import "react-rater/lib/react-rater.css";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { getValByLang, checkScreenLaptop } from "../../../utils/helpers";
import MainPage from "./MainPage/MainPage";
import SideBarStore from "./SideBarStore";
import ProductStore from "./ProductStore";
import { useParams } from "react-router-dom";
import { setCategorySelected, setCategorySelectedWithoutReset } from "../../../services/store/storeSlice";
import { useDispatch } from "react-redux";
import { ArrowCircleLeftOutlined as ArrowCircleLeftOutlinedIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
//   const {slug} = useParams();

export default function CategoryPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [categoryPageData, setCategoryPageData] = useState(null);
    const { language } = useSelector((state) => state.global);
    const {
        search_term,
        CategorySelected,
        isLoading,
        attributesAvailable,
        categories,
        categoriesAvailable
    } = useSelector((state) => state.store);
    const { screenWidth, mediumWidthScreen } = useSelector(
        (state) => state.global
    );
    const { slug } = useParams();


    useEffect(() => {
        if (slug && categories.length > 0) {
            const category = categories.find((cat) => cat.slug === slug);
            if (category) {
                console.log("Category found:", category);
                setCategoryPageData(category.page_content || null);
                console.log("Category page data:", categoryPageData);
                if (CategorySelected == 0) {
                    // If no category is selected or the selected category does not include the current one, update the selection
                    dispatch(setCategorySelected([category.id, ...category.all_child]));
                }
            } else {
                console.error("Category not found for slug:", slug);
            }
        }
    }, [slug, categories, dispatch, categoryPageData, CategorySelected]);


    useEffect(() => {
        if (
            typeof window !== "undefined" &&
            categoryPageData &&
            categoriesAvailable &&
            attributesAvailable &&
            !isLoading
        ) {
            window.prerenderReady = true;
        }
    }, [categoryPageData, categoriesAvailable, attributesAvailable, isLoading]);

    return (
        <>
            <Helmet>
                <title>{getValByLang(categoryPageData?.meta?.title, language) || "Shop • Deliverit UAE"}</title>
                <meta name="description" content={getValByLang(categoryPageData?.meta?.description, language) || "Deliverit UAE - Browse the latest deals, new arrivals, and best-rated products."} />
                <meta name="keywords" content={getValByLang(categoryPageData?.meta?.keywords, language) || ""} />
                <meta property="og:title" content={getValByLang(categoryPageData?.meta?.["og:title"], language) || ""} />
                <meta property="og:description" content={getValByLang(categoryPageData?.meta?.["og:description"], language) || ""} />
                <meta property="og:url" content={getValByLang(categoryPageData?.meta?.["og:url"], language) || ""} />
                <meta property="og:type" content={getValByLang(categoryPageData?.meta?.["og:type"], language) || ""} />
                <meta property="og:image" content={getValByLang(categoryPageData?.meta?.["og:image"], language) || ""} />
                <meta name="twitter:card" content={getValByLang(categoryPageData?.meta?.["twitter:card"], language) || ""} />
                <meta name="twitter:title" content={getValByLang(categoryPageData?.meta?.["twitter:title"], language) || ""} />
                <meta name="twitter:description" content={getValByLang(categoryPageData?.meta?.["twitter:description"], language) || ""} />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        name: "Deliverit",
                        url: "https://shop.deliverit.ae",
                    })}
                </script>
            </Helmet>

            <Box>
                <Container className="no-padding page_size">
                    {/* Show category page title/description if available */}
                    <Container className="no-padding page_size d-flex " sx={{ display: "flex",justifyContent: "start", alignItems: "center" }}>
                        <Button onClick={() => { navigate('/') }}>
                            <ArrowCircleLeftOutlinedIcon className="back-to-home" />
                        </Button>

                        {categoryPageData && (
                            <Box className="category-top-content"  px={5}>
                                {categoryPageData.title != null && <h1>{categoryPageData.title}</h1>}
                                {categoryPageData.description != null &&
                                    <p>{categoryPageData.description}</p>
                                }

                            </Box>

                        )}
                    </Container>

                    <Grid container>
                        {checkScreenLaptop(screenWidth, mediumWidthScreen) ? (
                            <>
                                <Grid size={{ lg: 2, md: 4, sm: 4, xs: 6 }}>
                                    <SideBarStore
                                        className="store_sidebar"
                                        isLoading={isLoading}
                                        attributesAvailable={attributesAvailable}
                                        categoriesAvailable={categoriesAvailable}
                                    />
                                </Grid>
                                <Grid size={{ lg: 10, md: 8, sm: 8, xs: 6 }}>
                                    <ProductStore />
                                </Grid>
                            </>
                        ) : (
                            <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                                <ProductStore />
                            </Grid>
                        )}
                    </Grid>
                </Container>
            </Box>
        </>
    );
}